import React, { useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  Card,
  CardContent,
  CardActions,
  TextField,
  Button,
  Switch,
  FormControlLabel,
  FormGroup,
  Divider,
  Avatar,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Alert,
  Chip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tabs,
  Tab,
  Slider,
  RadioGroup,
  Radio,
  FormLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import {
  Person as PersonIcon,
  Security as SecurityIcon,
  Notifications as NotificationsIcon,
  Language as LanguageIcon,
  Palette as PaletteIcon,
  Work as WorkIcon,
  PrivacyTip as PrivacyIcon,
  Save as SaveIcon,
  Edit as EditIcon,
  PhotoCamera as PhotoCameraIcon,
  Key as KeyIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  Schedule as ScheduleIcon,
  DarkMode as DarkModeIcon,
  LightMode as LightModeIcon,
  VolumeUp as VolumeUpIcon,
  Visibility as VisibilityIcon,
  LocationOn as LocationOnIcon,
  ExpandMore as ExpandMoreIcon,
  Warning as WarningIcon,
  CheckCircle as CheckCircleIcon
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';

const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: theme.shadows[8],
  },
}));

const GradientHeader = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  color: 'white',
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(3),
}));

const EmployeeSettings = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const [language, setLanguage] = useState('bn');
  const [showSaveAlert, setShowSaveAlert] = useState(false);
  const [changePasswordDialog, setChangePasswordDialog] = useState(false);
  const [profileData, setProfileData] = useState({
    name: 'মোহাম্মদ করিম',
    email: 'karim@grameenbazar.com',
    phone: '০১৭১২৩৪৫৬৭৮',
    employeeId: 'EMP-001',
    designation: 'প্রোডাক্ট ম্যানেজার',
    department: 'অপারেশন',
    joinDate: '২০২৩-০১-১৫',
    address: 'ঢাকা, বাংলাদেশ'
  });

  const [notifications, setNotifications] = useState({
    orderAlerts: true,
    taskReminders: true,
    systemUpdates: false,
    emailNotifications: true,
    pushNotifications: true,
    smsAlerts: false,
    weeklyReports: true,
    emergencyAlerts: true
  });

  const [workPreferences, setWorkPreferences] = useState({
    workingHours: '৯:০০ AM - ৬:০০ PM',
    breakTime: '১২:০০ PM - ১:০০ PM',
    availableWeekends: false,
    overtimePreference: true,
    remoteWork: false,
    taskPriority: 'balanced'
  });

  const [appSettings, setAppSettings] = useState({
    theme: 'light',
    fontSize: 'medium',
    autoSave: true,
    soundEffects: true,
    animations: true,
    compactView: false,
    defaultView: 'dashboard'
  });

  // Translations
  const translations = {
    bn: {
      title: 'সেটিংস',
      profile: 'প্রোফাইল',
      security: 'নিরাপত্তা',
      notifications: 'বিজ্ঞপ্তি',
      workPrefs: 'কাজের পছন্দ',
      appSettings: 'অ্যাপ সেটিংস',
      privacy: 'গোপনীয়তা',
      save: 'সংরক্ষণ করুন',
      cancel: 'বাতিল',
      edit: 'সম্পাদনা',
      changePassword: 'পাসওয়ার্ড পরিবর্তন',
      currentPassword: 'বর্তমান পাসওয়ার্ড',
      newPassword: 'নতুন পাসওয়ার্ড',
      confirmPassword: 'পাসওয়ার্ড নিশ্চিত করুন',
      personalInfo: 'ব্যক্তিগত তথ্য',
      contactInfo: 'যোগাযোগের তথ্য',
      workInfo: 'কাজের তথ্য',
      name: 'নাম',
      email: 'ইমেইল',
      phone: 'ফোন',
      employeeId: 'কর্মচারী আইডি',
      designation: 'পদবী',
      department: 'বিভাগ',
      joinDate: 'যোগদানের তারিখ',
      address: 'ঠিকানা',
      settingsSaved: 'সেটিংস সফলভাবে সংরক্ষিত হয়েছে!',
      orderAlerts: 'অর্ডার সতর্কতা',
      taskReminders: 'কাজের রিমাইন্ডার',
      systemUpdates: 'সিস্টেম আপডেট',
      emailNotifications: 'ইমেইল বিজ্ঞপ্তি',
      pushNotifications: 'পুশ বিজ্ঞপ্তি',
      smsAlerts: 'এসএমএস সতর্কতা',
      weeklyReports: 'সাপ্তাহিক রিপোর্ট',
      emergencyAlerts: 'জরুরি সতর্কতা',
      workingHours: 'কাজের সময়',
      breakTime: 'বিরতির সময়',
      availableWeekends: 'সপ্তাহান্তে কাজ',
      overtimePreference: 'অতিরিক্ত সময় কাজ',
      remoteWork: 'দূরবর্তী কাজ',
      taskPriority: 'কাজের অগ্রাধিকার',
      theme: 'থিম',
      fontSize: 'ফন্ট সাইজ',
      autoSave: 'স্বয়ংক্রিয় সংরক্ষণ',
      soundEffects: 'সাউন্ড ইফেক্ট',
      animations: 'অ্যানিমেশন',
      compactView: 'কমপ্যাক্ট ভিউ',
      defaultView: 'ডিফল্ট ভিউ',
      light: 'হালকা',
      dark: 'গাঢ়',
      small: 'ছোট',
      medium: 'মাঝারি',
      large: 'বড়',
      balanced: 'সুষম',
      quality: 'গুণমান',
      speed: 'গতি',
      dashboard: 'ড্যাশবোর্ড',
      tasks: 'কাজসমূহ',
      orders: 'অর্ডার'
    },
    en: {
      title: 'Settings',
      profile: 'Profile',
      security: 'Security',
      notifications: 'Notifications',
      workPrefs: 'Work Preferences',
      appSettings: 'App Settings',
      privacy: 'Privacy',
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit',
      changePassword: 'Change Password',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      personalInfo: 'Personal Information',
      contactInfo: 'Contact Information',
      workInfo: 'Work Information',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      employeeId: 'Employee ID',
      designation: 'Designation',
      department: 'Department',
      joinDate: 'Join Date',
      address: 'Address',
      settingsSaved: 'Settings saved successfully!',
      orderAlerts: 'Order Alerts',
      taskReminders: 'Task Reminders',
      systemUpdates: 'System Updates',
      emailNotifications: 'Email Notifications',
      pushNotifications: 'Push Notifications',
      smsAlerts: 'SMS Alerts',
      weeklyReports: 'Weekly Reports',
      emergencyAlerts: 'Emergency Alerts',
      workingHours: 'Working Hours',
      breakTime: 'Break Time',
      availableWeekends: 'Available Weekends',
      overtimePreference: 'Overtime Preference',
      remoteWork: 'Remote Work',
      taskPriority: 'Task Priority',
      theme: 'Theme',
      fontSize: 'Font Size',
      autoSave: 'Auto Save',
      soundEffects: 'Sound Effects',
      animations: 'Animations',
      compactView: 'Compact View',
      defaultView: 'Default View',
      light: 'Light',
      dark: 'Dark',
      small: 'Small',
      medium: 'Medium',
      large: 'Large',
      balanced: 'Balanced',
      quality: 'Quality',
      speed: 'Speed',
      dashboard: 'Dashboard',
      tasks: 'Tasks',
      orders: 'Orders'
    }
  };

  const t = translations[language];

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const handleSave = () => {
    setShowSaveAlert(true);
    setTimeout(() => setShowSaveAlert(false), 3000);
  };

  const handleNotificationChange = (key) => (event) => {
    setNotifications(prev => ({
      ...prev,
      [key]: event.target.checked
    }));
  };

  const handleWorkPreferenceChange = (key) => (event) => {
    setWorkPreferences(prev => ({
      ...prev,
      [key]: event.target.checked || event.target.value
    }));
  };

  const handleAppSettingChange = (key) => (event) => {
    setAppSettings(prev => ({
      ...prev,
      [key]: event.target.checked || event.target.value
    }));
  };

  const TabPanel = ({ children, value, index, ...other }) => (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`settings-tabpanel-${index}`}
      aria-labelledby={`settings-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );

  return (
    <Box>
      <GradientHeader>
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 600 }}>
          {t.title}
        </Typography>
        <Typography variant="body1" sx={{ opacity: 0.9 }}>
          আপনার অ্যাকাউন্ট এবং কাজের পছন্দসমূহ কাস্টমাইজ করুন
        </Typography>
      </GradientHeader>

      {showSaveAlert && (
        <Alert 
          severity="success" 
          icon={<CheckCircleIcon fontSize="inherit" />}
          sx={{ mb: 3 }}
        >
          {t.settingsSaved}
        </Alert>
      )}

      <Paper sx={{ width: '100%' }}>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            '& .MuiTab-root': {
              minWidth: 120,
              fontWeight: 500
            }
          }}
        >
          <Tab icon={<PersonIcon />} label={t.profile} />
          <Tab icon={<SecurityIcon />} label={t.security} />
          <Tab icon={<NotificationsIcon />} label={t.notifications} />
          <Tab icon={<WorkIcon />} label={t.workPrefs} />
          <Tab icon={<PaletteIcon />} label={t.appSettings} />
          <Tab icon={<PrivacyIcon />} label={t.privacy} />
        </Tabs>

        {/* Profile Tab */}
        <TabPanel value={currentTab} index={0}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <StyledCard>
                <CardContent sx={{ textAlign: 'center', p: 4 }}>
                  <Box sx={{ position: 'relative', display: 'inline-block', mb: 2 }}>
                    <Avatar
                      sx={{
                        width: 120,
                        height: 120,
                        bgcolor: 'primary.main',
                        fontSize: '3rem',
                        mx: 'auto'
                      }}
                    >
                      ক
                    </Avatar>
                    <IconButton
                      sx={{
                        position: 'absolute',
                        bottom: 0,
                        right: 0,
                        bgcolor: 'primary.main',
                        color: 'white',
                        '&:hover': { bgcolor: 'primary.dark' }
                      }}
                      size="small"
                    >
                      <PhotoCameraIcon />
                    </IconButton>
                  </Box>
                  <Typography variant="h6" gutterBottom>
                    {profileData.name}
                  </Typography>
                  <Chip 
                    label={profileData.designation}
                    color="primary"
                    variant="outlined"
                    sx={{ mb: 1 }}
                  />
                  <Typography variant="body2" color="text.secondary">
                    {profileData.department}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    আইডি: {profileData.employeeId}
                  </Typography>
                </CardContent>
              </StyledCard>
            </Grid>

            <Grid item xs={12} md={8}>
              <StyledCard>
                <CardContent>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
                    {t.personalInfo}
                  </Typography>
                  
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label={t.name}
                        value={profileData.name}
                        variant="outlined"
                        InputProps={{
                          startAdornment: <PersonIcon sx={{ mr: 1, color: 'text.secondary' }} />
                        }}
                      />
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label={t.employeeId}
                        value={profileData.employeeId}
                        variant="outlined"
                        disabled
                        InputProps={{
                          startAdornment: <PersonIcon sx={{ mr: 1, color: 'text.secondary' }} />
                        }}
                      />
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label={t.email}
                        value={profileData.email}
                        variant="outlined"
                        InputProps={{
                          startAdornment: <EmailIcon sx={{ mr: 1, color: 'text.secondary' }} />
                        }}
                      />
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label={t.phone}
                        value={profileData.phone}
                        variant="outlined"
                        InputProps={{
                          startAdornment: <PhoneIcon sx={{ mr: 1, color: 'text.secondary' }} />
                        }}
                      />
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label={t.designation}
                        value={profileData.designation}
                        variant="outlined"
                        disabled
                        InputProps={{
                          startAdornment: <WorkIcon sx={{ mr: 1, color: 'text.secondary' }} />
                        }}
                      />
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label={t.department}
                        value={profileData.department}
                        variant="outlined"
                        disabled
                        InputProps={{
                          startAdornment: <WorkIcon sx={{ mr: 1, color: 'text.secondary' }} />
                        }}
                      />
                    </Grid>
                    
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label={t.address}
                        value={profileData.address}
                        variant="outlined"
                        multiline
                        rows={2}
                        InputProps={{
                          startAdornment: <LocationOnIcon sx={{ mr: 1, color: 'text.secondary', alignSelf: 'flex-start', mt: 1 }} />
                        }}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
                <CardActions sx={{ p: 3, pt: 0 }}>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={handleSave}
                    sx={{ mr: 2 }}
                  >
                    {t.save}
                  </Button>
                  <Button variant="outlined">
                    {t.cancel}
                  </Button>
                </CardActions>
              </StyledCard>
            </Grid>
          </Grid>
        </TabPanel>

        {/* Security Tab */}
        <TabPanel value={currentTab} index={1}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <StyledCard>
                <CardContent>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
                    পাসওয়ার্ড এবং নিরাপত্তা
                  </Typography>
                  
                  <List>
                    <ListItem>
                      <ListItemIcon>
                        <KeyIcon color="primary" />
                      </ListItemIcon>
                      <ListItemText
                        primary="পাসওয়ার্ড পরিবর্তন করুন"
                        secondary="শেষ পরিবর্তন: ৩০ দিন আগে"
                      />
                      <ListItemSecondaryAction>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => setChangePasswordDialog(true)}
                        >
                          পরিবর্তন
                        </Button>
                      </ListItemSecondaryAction>
                    </ListItem>
                    
                    <Divider />
                    
                    <ListItem>
                      <ListItemIcon>
                        <SecurityIcon color="success" />
                      </ListItemIcon>
                      <ListItemText
                        primary="দ্বি-ফ্যাক্টর অথেন্টিকেশন"
                        secondary="আপনার অ্যাকাউন্ট সুরক্ষিত"
                      />
                      <ListItemSecondaryAction>
                        <Switch defaultChecked />
                      </ListItemSecondaryAction>
                    </ListItem>
                    
                    <Divider />
                    
                    <ListItem>
                      <ListItemIcon>
                        <PhoneIcon color="primary" />
                      </ListItemIcon>
                      <ListItemText
                        primary="এসএমএস ভেরিফিকেশন"
                        secondary="লগইনের জন্য এসএমএস কোড প্রয়োজন"
                      />
                      <ListItemSecondaryAction>
                        <Switch />
                      </ListItemSecondaryAction>
                    </ListItem>
                  </List>
                </CardContent>
              </StyledCard>
            </Grid>
            
            <Grid item xs={12} md={6}>
              <StyledCard>
                <CardContent>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
                    লগইন কার্যকলাপ
                  </Typography>
                  
                  <List>
                    <ListItem>
                      <ListItemText
                        primary="আজ ৯:১৫ AM"
                        secondary="Windows PC - Chrome"
                        secondaryTypographyProps={{ color: 'success.main' }}
                      />
                      <Chip label="বর্তমান" color="success" size="small" />
                    </ListItem>
                    
                    <ListItem>
                      <ListItemText
                        primary="কাল ৬:৩২ PM"
                        secondary="Android - Mobile App"
                      />
                      <Chip label="সফল" color="default" size="small" />
                    </ListItem>
                    
                    <ListItem>
                      <ListItemText
                        primary="২ দিন আগে ১০:২২ AM"
                        secondary="Windows PC - Chrome"
                      />
                      <Chip label="সফল" color="default" size="small" />
                    </ListItem>
                  </List>
                </CardContent>
              </StyledCard>
            </Grid>
          </Grid>
        </TabPanel>

        {/* Notifications Tab */}
        <TabPanel value={currentTab} index={2}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <StyledCard>
                <CardContent>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
                    কাজ সম্পর্কিত বিজ্ঞপ্তি
                  </Typography>
                  
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={notifications.orderAlerts}
                          onChange={handleNotificationChange('orderAlerts')}
                        />
                      }
                      label={t.orderAlerts}
                    />
                    <FormControlLabel
                      control={
                        <Switch
                          checked={notifications.taskReminders}
                          onChange={handleNotificationChange('taskReminders')}
                        />
                      }
                      label={t.taskReminders}
                    />
                    <FormControlLabel
                      control={
                        <Switch
                          checked={notifications.weeklyReports}
                          onChange={handleNotificationChange('weeklyReports')}
                        />
                      }
                      label={t.weeklyReports}
                    />
                    <FormControlLabel
                      control={
                        <Switch
                          checked={notifications.emergencyAlerts}
                          onChange={handleNotificationChange('emergencyAlerts')}
                        />
                      }
                      label={t.emergencyAlerts}
                    />
                  </FormGroup>
                </CardContent>
              </StyledCard>
            </Grid>
            
            <Grid item xs={12} md={6}>
              <StyledCard>
                <CardContent>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
                    যোগাযোগের মাধ্যম
                  </Typography>
                  
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={notifications.emailNotifications}
                          onChange={handleNotificationChange('emailNotifications')}
                        />
                      }
                      label={t.emailNotifications}
                    />
                    <FormControlLabel
                      control={
                        <Switch
                          checked={notifications.pushNotifications}
                          onChange={handleNotificationChange('pushNotifications')}
                        />
                      }
                      label={t.pushNotifications}
                    />
                    <FormControlLabel
                      control={
                        <Switch
                          checked={notifications.smsAlerts}
                          onChange={handleNotificationChange('smsAlerts')}
                        />
                      }
                      label={t.smsAlerts}
                    />
                    <FormControlLabel
                      control={
                        <Switch
                          checked={notifications.systemUpdates}
                          onChange={handleNotificationChange('systemUpdates')}
                        />
                      }
                      label={t.systemUpdates}
                    />
                  </FormGroup>
                </CardContent>
              </StyledCard>
            </Grid>
          </Grid>
        </TabPanel>

        {/* Work Preferences Tab */}
        <TabPanel value={currentTab} index={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <StyledCard>
                <CardContent>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
                    কাজের সময়সূচী
                  </Typography>
                  
                  <Box sx={{ mb: 3 }}>
                    <TextField
                      fullWidth
                      label={t.workingHours}
                      value={workPreferences.workingHours}
                      variant="outlined"
                      sx={{ mb: 2 }}
                      InputProps={{
                        startAdornment: <ScheduleIcon sx={{ mr: 1, color: 'text.secondary' }} />
                      }}
                    />
                    
                    <TextField
                      fullWidth
                      label={t.breakTime}
                      value={workPreferences.breakTime}
                      variant="outlined"
                      InputProps={{
                        startAdornment: <ScheduleIcon sx={{ mr: 1, color: 'text.secondary' }} />
                      }}
                    />
                  </Box>
                  
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={workPreferences.availableWeekends}
                          onChange={handleWorkPreferenceChange('availableWeekends')}
                        />
                      }
                      label={t.availableWeekends}
                    />
                    <FormControlLabel
                      control={
                        <Switch
                          checked={workPreferences.overtimePreference}
                          onChange={handleWorkPreferenceChange('overtimePreference')}
                        />
                      }
                      label={t.overtimePreference}
                    />
                    <FormControlLabel
                      control={
                        <Switch
                          checked={workPreferences.remoteWork}
                          onChange={handleWorkPreferenceChange('remoteWork')}
                        />
                      }
                      label={t.remoteWork}
                    />
                  </FormGroup>
                </CardContent>
              </StyledCard>
            </Grid>
            
            <Grid item xs={12} md={6}>
              <StyledCard>
                <CardContent>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
                    কাজের পছন্দ
                  </Typography>
                  
                  <FormControl fullWidth sx={{ mb: 3 }}>
                    <FormLabel component="legend">কাজের অগ্রাধিকার</FormLabel>
                    <RadioGroup
                      value={workPreferences.taskPriority}
                      onChange={handleWorkPreferenceChange('taskPriority')}
                    >
                      <FormControlLabel value="speed" control={<Radio />} label="দ্রুততা প্রাধান্য" />
                      <FormControlLabel value="quality" control={<Radio />} label="গুণমান প্রাধান্য" />
                      <FormControlLabel value="balanced" control={<Radio />} label="সুষম পদ্ধতি" />
                    </RadioGroup>
                  </FormControl>
                </CardContent>
              </StyledCard>
            </Grid>
          </Grid>
        </TabPanel>

        {/* App Settings Tab */}
        <TabPanel value={currentTab} index={4}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <StyledCard>
                <CardContent>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
                    প্রদর্শন সেটিংস
                  </Typography>
                  
                  <FormControl fullWidth sx={{ mb: 3 }}>
                    <InputLabel>{t.theme}</InputLabel>
                    <Select
                      value={appSettings.theme}
                      label={t.theme}
                      onChange={handleAppSettingChange('theme')}
                    >
                      <MenuItem value="light">
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <LightModeIcon sx={{ mr: 1 }} />
                          {t.light}
                        </Box>
                      </MenuItem>
                      <MenuItem value="dark">
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <DarkModeIcon sx={{ mr: 1 }} />
                          {t.dark}
                        </Box>
                      </MenuItem>
                    </Select>
                  </FormControl>
                  
                  <FormControl fullWidth sx={{ mb: 3 }}>
                    <InputLabel>{t.fontSize}</InputLabel>
                    <Select
                      value={appSettings.fontSize}
                      label={t.fontSize}
                      onChange={handleAppSettingChange('fontSize')}
                    >
                      <MenuItem value="small">{t.small}</MenuItem>
                      <MenuItem value="medium">{t.medium}</MenuItem>
                      <MenuItem value="large">{t.large}</MenuItem>
                    </Select>
                  </FormControl>
                  
                  <FormControl fullWidth>
                    <InputLabel>{t.defaultView}</InputLabel>
                    <Select
                      value={appSettings.defaultView}
                      label={t.defaultView}
                      onChange={handleAppSettingChange('defaultView')}
                    >
                      <MenuItem value="dashboard">{t.dashboard}</MenuItem>
                      <MenuItem value="tasks">{t.tasks}</MenuItem>
                      <MenuItem value="orders">{t.orders}</MenuItem>
                    </Select>
                  </FormControl>
                </CardContent>
              </StyledCard>
            </Grid>
            
            <Grid item xs={12} md={6}>
              <StyledCard>
                <CardContent>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
                    অ্যাপ আচরণ
                  </Typography>
                  
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={appSettings.autoSave}
                          onChange={handleAppSettingChange('autoSave')}
                        />
                      }
                      label={t.autoSave}
                    />
                    <FormControlLabel
                      control={
                        <Switch
                          checked={appSettings.soundEffects}
                          onChange={handleAppSettingChange('soundEffects')}
                        />
                      }
                      label={t.soundEffects}
                    />
                    <FormControlLabel
                      control={
                        <Switch
                          checked={appSettings.animations}
                          onChange={handleAppSettingChange('animations')}
                        />
                      }
                      label={t.animations}
                    />
                    <FormControlLabel
                      control={
                        <Switch
                          checked={appSettings.compactView}
                          onChange={handleAppSettingChange('compactView')}
                        />
                      }
                      label={t.compactView}
                    />
                  </FormGroup>
                </CardContent>
              </StyledCard>
            </Grid>
          </Grid>
        </TabPanel>

        {/* Privacy Tab */}
        <TabPanel value={currentTab} index={5}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <StyledCard>
                <CardContent>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
                    গোপনীয়তা এবং ডেটা
                  </Typography>
                  
                  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography>ডেটা রপ্তানি</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography paragraph>
                        আপনার ব্যক্তিগত ডেটা এবং কার্যকলাপের তথ্য ডাউনলোড করুন।
                      </Typography>
                      <Button variant="outlined" startIcon={<VisibilityIcon />}>
                        ডেটা ডাউনলোড করুন
                      </Button>
                    </AccordionDetails>
                  </Accordion>
                  
                  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography>অ্যাকাউন্ট মুছে ফেলা</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Alert severity="warning" sx={{ mb: 2 }}>
                        এই কাজটি স্থায়ী এবং এটি পূর্বাবস্থায় ফেরানো যাবে না।
                      </Alert>
                      <Typography paragraph>
                        আপনার অ্যাকাউন্ট এবং সমস্ত সংশ্লিষ্ট ডেটা স্থায়ীভাবে মুছে ফেলা হবে।
                      </Typography>
                      <Button variant="outlined" color="error" startIcon={<WarningIcon />}>
                        অ্যাকাউন্ট মুছে ফেলুন
                      </Button>
                    </AccordionDetails>
                  </Accordion>
                </CardContent>
              </StyledCard>
            </Grid>
          </Grid>
        </TabPanel>
      </Paper>

      {/* Change Password Dialog */}
      <Dialog open={changePasswordDialog} onClose={() => setChangePasswordDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>পাসওয়ার্ড পরিবর্তন করুন</DialogTitle>
        <DialogContent>
          <Box sx={{ pt: 2 }}>
            <TextField
              fullWidth
              label="বর্তমান পাসওয়ার্ড"
              type="password"
              variant="outlined"
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label="নতুন পাসওয়ার্ড"
              type="password"
              variant="outlined"
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label="নতুন পাসওয়ার্ড নিশ্চিত করুন"
              type="password"
              variant="outlined"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setChangePasswordDialog(false)}>বাতিল</Button>
          <Button variant="contained" onClick={() => setChangePasswordDialog(false)}>
            পরিবর্তন করুন
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default EmployeeSettings; 